export const baseUrl = import.meta.env.VITE_REACT_APP_API_URL || '';
export const baseUrlV1 = `${baseUrl}/api/v1`;
export const baseUrlV2 = `${baseUrl}/api/v2`;
export const baseUrlFiles = `${baseUrl}/uploads/files/`;
export const LANDING = import.meta.env.VITE_REACT_APP_API_URL_LANDING || 'https://zingizi.pro';

export const billingServiceBaseUrl = `${baseUrl}/api/v2/billing-service`;
export const offlineAudioServiceBaseUrl = `${baseUrl}/api/v2/offline-consultation-audio`;
/** Путь для IRI консультации (используется в payload и ссылках). */
export const consultationService =
  import.meta.env.VITE_CONSULTATION_API_URL?.replace(/\/$/, '') || `${baseUrl}/api/v2/consultation-service`;
export const psychologistServiceBaseUrl =
  import.meta.env.VITE_PSYCHOLOGIST_SERVICE_URL || `${baseUrl}/api/v2/psychologist-service`;
/** Account-профиль психолога (в т.ч. аватар в S3) развёрнут не на всех стендах — отдельный override.
 * Dev: относительный путь (проксируется через vite), Prod: абсолютный URL через VITE_PSYCHOLOGIST_PROFILE_URL. */
const profileUrlOverride = import.meta.env.VITE_PSYCHOLOGIST_PROFILE_URL;
export const psychologistProfileBaseUrl = profileUrlOverride || '/api/v2/psychologist-service';

export const catalogProfilePublicUrl =
  import.meta.env.VITE_CATALOG_PROFILE_URL || 'https://catalog.zingizi.pro/psychologist';
